import React, { useState, useEffect } from 'react';
import { DataListInput, DateInput, TextInput } from '../forms/Input';
import { PrimaryButton, SecondaryButton } from '../forms/buttons';
import toast from 'react-hot-toast';
import api, { API_URL } from '../../api';

const AddHospitalPopup = ({ onClose, onSubmit, sectionExpired }) => {

    const [hospitalName, setHospitalName] = useState('');
    const [hospitalAddress, setHospitalAddress] = useState('');
    const [hospitalPhoneNumber, setPhoneNumber] = useState('');
    const [ccnNumber, setCcnNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [measures, setMeasures] = useState([]);
    const [formError, setFormError] = useState('');

    const isFormValid = hospitalName.trim() && hospitalAddress.trim() && hospitalPhoneNumber.trim() && ccnNumber.trim();

    useEffect(() => {
        const fetchMeasures = async () => {
            setIsLoading(true);
            try {
                const response = await api.get(`${API_URL}/measures/`);
                const data = response.data;
                const measuresArray = []
                data.forEach(item => {
                    measuresArray.push(item['name'])
                })

                setMeasures(measuresArray)

            } catch (error) {
                console.error('Error fetching measures:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchMeasures();
    }, []);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        console.log("Submitting form...");
        if (isSubmitting) return;
        setIsSubmitting(true);

        // Validate required fields
        const missingFields = [];
        if (!hospitalName.trim()) missingFields.push('Hospital Name');
        if (!hospitalAddress.trim()) missingFields.push('Address');
        if (!hospitalPhoneNumber.trim()) missingFields.push('Phone Number');
        if (!ccnNumber.trim()) missingFields.push('CMS Certification Number (CCN)');

        if (missingFields.length > 0) {
            setFormError('All fields are required');
            setIsSubmitting(false);
            return;
        }

        setFormError('');

        try {
            const newHospital = {
                name: hospitalName.trim(),
                address: hospitalAddress.trim(),
                phone_number: hospitalPhoneNumber.trim(),
                ccn_number: ccnNumber.trim()
            };

            setIsLoading(true);
            const response = await api.post(`${API_URL}/hospitals/new_hospital/`, newHospital);

            if (response.status === 200 || response.status === 201) {
                toast.success("Hospital successfully added");
                setTimeout(() => {
                    if (sectionExpired) {
                        window.location.reload();
                    } else {
                        // Reloading the page to reflect changes
                        window.location.reload();
                    }
                    onClose();
                }, 1500);
            } else {
                toast.error("Failed to add Hospital");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            if (error.response) {
                const detail = error.response.data.detail || error.response.data.message || JSON.stringify(error.response.data);
                setFormError('Error: ' + detail);
                toast.error('Error: ' + detail);
            } else {
                setFormError('Something went wrong. Please try again');
                toast.error('Something went wrong. Please try again');
            }
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    };

    return (
        <div className='popup-overlay'>
            <form className='add-target-popup' onSubmit={handleSubmit}>
                <h1 className='title'>Add Hospital</h1>
                {formError && <div className="form-error-message" style={{ color: 'red', marginBottom: '10px' }}>{formError}</div>}

                <div className='form-group'>
                    <TextInput
                        label="Hospital Name"
                        id="name"
                        name="name"
                        placeholder="Hospital Name"
                        value={hospitalName}
                        setValue={setHospitalName}
                        required
                        errorMessage="Hospital name is required"
                    />
                </div>
                <div className='form-group'>
                    <TextInput
                        label="Address"
                        id="address"
                        name="address"
                        placeholder="Address"
                        value={hospitalAddress}
                        setValue={setHospitalAddress}
                        required
                        errorMessage="Hospital address is required"
                    />
                </div>
                <div className='form-group'>
                    <TextInput
                        label="Phone Number"
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="Phone Number"
                        value={hospitalPhoneNumber}
                        setValue={setPhoneNumber}
                        required
                        pattern="^[\+]?[0-9\s\-\(\)]*$"
                        errorMessage="Phone number is required and can only contain +, numbers, spaces, hyphens, and parentheses"
                    />
                </div>
                <div className='form-group'>
                    <TextInput
                        label="CMS Certification Number (CCN)"
                        id="cnn"
                        name="cnn"
                        placeholder="CMS Certification Number (CCN)"
                        value={ccnNumber}
                        setValue={setCcnNumber}
                        required
                        errorMessage="CMS Certification Number (CCN) is required"
                    />
                </div>

                <div className='buttons'>
                    <SecondaryButton
                        onClick={onClose}
                        buttonText='Cancel'
                        type="button"
                    />
                    <PrimaryButton
                        isLoading={isSubmitting}
                        onClick={handleSubmit}
                        type='button'
                        processingText='Submitting'
                        buttonText='Save'
                        disabled={!isFormValid || isSubmitting}
                    />
                </div>
            </form>
        </div>
    );
};

export default AddHospitalPopup;
